// removed by extract-text-webpack-plugin
module.exports = {"theme_BigStone":"Layout__theme_BigStone__ioLpF","theme_ClamShell":"Layout__theme_ClamShell__1rhLR","LayoutContainer":"Layout__LayoutContainer__1rVjN","Main":"Layout__Main__29PO5","connectionMessage":"Layout__connectionMessage__1QbJS","showSidebar":"Layout__showSidebar__2oLZF"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.css
// module id = 86
// module chunks = 0